import $ from "jquery";
import moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { PersonneAChargeDto } from "../../../dto/GenApi.iNotPaie.Dto/PersonneAChargeDto";
import { SalarieDeclarationDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieDeclarationDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EventBus } from "../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import ModalAjoutEditPersonnes from "./ajoutEditPersonne/modalAjoutEditPersonnes";

interface salarieChargeInfos {
    errorMessage: string[];
    isModified: boolean;
    salarieCourant?: SalarieDeclarationDto;
    dateUnion: string;
    datePermis: string;
    dateCarteSejour: string;
    dateFinCarteSejour: string;
    dateLogementPourcentPatronal: string;
}

@Component({
    components: {
        ModalAjoutEditPersonnes: require("./ajoutEditPersonne/modalAjoutEditPersonnes.vue.html")
    }
})

export default class DeclarationsSalarieComponent extends Vue {
    public canModify = false;
    public isModDemarrage = false;
    public currentId = 0;
    public dataReady = false;
    public isModified = false;
    public errorMessage: string[] = [];
    public salarieCourant?: SalarieDeclarationDto = undefined;
    public salarieCharges: salarieChargeInfos[] = [];
    public dateUnion = "";
    public datePermis = "";
    public dateCarteSejour = "";
    public dateFinCarteSejour = "";
    public dateLogementPourcentPatronal = "";
    public modalAjoutEditPersonnes?: ModalAjoutEditPersonnes = undefined;
    public listeLieuVote: ParametreDto[] = [];
    public listeSection: ParametreDto[] = [];
    public listeCollege: ParametreDto[] = [];
    public listeSituationMaritale: ParametreDto[] = [];
    public idPersonneAdded = -1;
    public isInitialized = false;
    public DateChangementLogiciel = "";
    public NumeroContratAncienLogiciel = "";

    public reloadData(id: number): void {
        if (this.currentId > 0) {
            this.salarieCharges[this.currentId] = {
                dateCarteSejour: this.dateCarteSejour,
                dateFinCarteSejour: this.dateFinCarteSejour,
                dateLogementPourcentPatronal: this.dateLogementPourcentPatronal,
                datePermis: this.datePermis,
                dateUnion: this.dateUnion,
                errorMessage: this.errorMessage,
                salarieCourant: this.salarieCourant,
                isModified: this.isModified
            };
        }
        this.currentId = id;
        this.fetchData();
    }

    public init(): void {
        if (this.isInitialized || ParametresInstance.utilisateurCourant == undefined) {
            return;
        }
        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]);

        this.initConstantes();
        this.modalAjoutEditPersonnes = this.$refs.modalAjoutEditPersonnes as ModalAjoutEditPersonnes;
        this.fetchData();

        this.isInitialized = true;
    }

    public mounted(): void {
        this.isInitialized = false;

        // On ne sait pas dans quel ordre ça peut arriver (1er appel ou refresh de la page...)
        EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
            this.init();
        });

        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
        });
        this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);

        this.init();
    }

    public resetData(id: number): void {
        if (this.salarieCharges[id] != undefined) {
            this.salarieCharges[id].isModified = false;
        }
        if (this.currentId == id) {
            this.fetchData();
        }
    }

    public initConstantes(): void {
        ServicesFactoryInstance.ParametresService.getLieuVotes(data => {
            this.listeLieuVote = data;
        });

        ServicesFactoryInstance.ParametresService.getColleges(data => {
            this.listeCollege = data;
        });

        ServicesFactoryInstance.ParametresService.getSituationMaritale(data => {
            this.listeSituationMaritale = data;
        });

        ServicesFactoryInstance.ParametresService.getSections(data => {
            this.listeSection = data;
        });
    }

    public fetchData(): void {
        if (this.currentId < 1) {
            return;
        }
        this.dataReady = false;
        if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
            if (isNaN(Number(this.$route.query.idContrat))) {
                ServicesFactoryInstance.SalarieService.getSalarieDeclaration(this.currentId, this.setData, () => this.dataReady = true);
            } else {
                ServicesFactoryInstance.SalarieService.getSalarieDeclarationForContrat(this.currentId, Number(this.$route.query.idContrat), this.setData, () => this.dataReady = true);
            }
        } else {
            this.dateUnion = this.salarieCharges[this.currentId].dateUnion;
            this.dateCarteSejour = this.salarieCharges[this.currentId].dateCarteSejour;
            this.dateFinCarteSejour = this.salarieCharges[this.currentId].dateFinCarteSejour;
            this.dateLogementPourcentPatronal = this.salarieCharges[this.currentId].dateLogementPourcentPatronal;
            this.datePermis = this.salarieCharges[this.currentId].datePermis;
            this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
            this.isModified = this.salarieCharges[this.currentId].isModified;
            this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
            this.dataReady = true;
        }
    }

    public setData(data: SalarieDeclarationDto): void {
        if (data.Id != this.currentId) {
            return;
        }

        this.salarieCourant = data;
        if (this.salarieCourant.Enfants == undefined) {
            this.salarieCourant.Enfants = [];
        }
        if (this.salarieCourant.Conjoints == undefined) {
            this.salarieCourant.Conjoints = [];
        }
        if (this.salarieCourant.AutresPersonnesACharge == undefined) {
            this.salarieCourant.AutresPersonnesACharge = [];
        }
        this.dateUnion = moment.utc(this.salarieCourant.DateUnion).format("YYYY-MM-DD");
        this.datePermis = moment.utc(this.salarieCourant.DatePermis).format("YYYY-MM-DD");
        this.dateFinCarteSejour = moment.utc(this.salarieCourant.DateFinCarteSejour).format("YYYY-MM-DD");
        this.dateLogementPourcentPatronal = moment.utc(this.salarieCourant.DateLogementPourcentPatronal).format("YYYY-MM-DD");
        this.dateCarteSejour = moment.utc(this.salarieCourant.DateCarteSejour).format("YYYY-MM-DD");
        this.DateChangementLogiciel = moment.utc(this.salarieCourant.DateChangementLogiciel).format("YYYY-MM-DD");
        this.dataReady = true;
    }

    public enregistrer(): boolean {
        if (this.salarieCourant == undefined) {
            return false;
        }

        this.salarieCourant.DateUnion = moment.utc(this.dateUnion).toDate();
        this.salarieCourant.DatePermis = moment.utc(this.datePermis).toDate();
        this.salarieCourant.DateFinCarteSejour = moment.utc(this.dateFinCarteSejour).toDate();
        this.salarieCourant.DateLogementPourcentPatronal = moment.utc(this.dateLogementPourcentPatronal).toDate();
        this.salarieCourant.DateCarteSejour = moment.utc(this.dateCarteSejour).toDate();
        this.salarieCourant.DateChangementLogiciel = moment.utc(this.DateChangementLogiciel).toDate();

        this.dataReady = false;
        ServicesFactoryInstance.SalarieService.updateSalarieDeclaration(this.salarieCourant, data => {
            this.setData(data);
            this.$emit("isModified", false);
            this.isModified = false;
            NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de l'enregistrement.");
            this.dataReady = true;
        });

        return false;
    }

    public addPersonne(type: string): void {
        this.modalAjoutEditPersonnes = this.$refs.modalAjoutEditPersonnes as ModalAjoutEditPersonnes;

        if (this.modalAjoutEditPersonnes == undefined) {
            return;
        }

        this.modalAjoutEditPersonnes.initialize({ Id: this.idPersonneAdded, IdSalarieFk: this.salarieCourant?.Id! }, type, true);
        this.idPersonneAdded--;

        $("#modalAjoutEditPersonnes").modal("show");
    }

    public editPersonne(personne: PersonneAChargeDto, type: string): void {
        this.modalAjoutEditPersonnes = this.$refs.modalAjoutEditPersonnes as ModalAjoutEditPersonnes;

        if (this.modalAjoutEditPersonnes == undefined) {
            return;
        }

        this.modalAjoutEditPersonnes.initialize(personne, type, false);

        $("#modalAjoutEditPersonnes").modal("show");
    }

    public deletePersonne(personne: PersonneAChargeDto, type: string): void {
        if (this.salarieCourant == undefined) {
            return;
        }
        switch (type) {
            case "C":
                this.salarieCourant.Conjoints = this.salarieCourant.Conjoints.filter(c => (c.Id != personne.Id && c.Id != 0) || (c.Id == 0 && personne.Id == 0 && c.Nom != personne.Nom && c.Prenom != personne.Prenom));
                break;
            case "E":
                this.salarieCourant.Enfants = this.salarieCourant.Enfants.filter(c => (c.Id != personne.Id && c.Id != 0) || (c.Id == 0 && personne.Id == 0 && c.Nom != personne.Nom && c.Prenom != personne.Prenom));
                break;
            case "A":
                this.salarieCourant.AutresPersonnesACharge = this.salarieCourant.AutresPersonnesACharge.filter(c => (c.Id != personne.Id && c.Id != 0) || (c.Id == 0 && personne.Id == 0 && c.Nom != personne.Nom && c.Prenom != personne.Prenom));
                break;
            default:
        }

        this.modify();
    }

    public ajoutPersonne(e: any): void {
        if (e == undefined || e.personne == undefined || e.type == undefined || e.personne as PersonneAChargeDto == undefined || this.salarieCourant == undefined) {
            return;
        }

        switch (e.type) {
            case "C":
                if (this.salarieCourant.Conjoints == undefined) {
                    this.salarieCourant.Conjoints = [];
                }
                this.salarieCourant.Conjoints.push(e.personne as PersonneAChargeDto);
                break;
            case "E":
                if (this.salarieCourant.Enfants == undefined) {
                    this.salarieCourant.Enfants = [];
                }
                this.salarieCourant.Enfants.push(e.personne as PersonneAChargeDto);
                break;
            case "A":
                if (this.salarieCourant.AutresPersonnesACharge == undefined) {
                    this.salarieCourant.AutresPersonnesACharge = [];
                }
                this.salarieCourant.AutresPersonnesACharge.push(e.personne as PersonneAChargeDto);
                break;
            default:
        }
        this.modify();
    }

    public modificationPersonne(e: any): void {
        if (e == undefined || e.personne == undefined || e.type == undefined || e.personne as PersonneAChargeDto == undefined || this.salarieCourant == undefined) {
            return;
        }

        const personne = e.personne as PersonneAChargeDto;
        let personneToUpdater: PersonneAChargeDto = { Id: 0, IdSalarieFk: 0 };

        switch (e.type) {
            case "C":
                personneToUpdater = this.salarieCourant.Conjoints.filter(p => p.Id == personne.Id)[0];
                break;
            case "E":
                personneToUpdater = this.salarieCourant.Enfants.filter(p => p.Id == personne.Id)[0];
                break;
            case "A":
                personneToUpdater = this.salarieCourant.AutresPersonnesACharge.filter(p => p.Id == personne.Id)[0];
                break;
            default:
        }

        if (personneToUpdater != undefined && personne != undefined) {
            personneToUpdater.Nom = personne.Nom;
            personneToUpdater.Prenom = personne.Prenom;
            personneToUpdater.DateFin = personne.DateFin;
            personneToUpdater.DateNaissance = personne.DateNaissance;
            personneToUpdater.LieuNaissance = personne.LieuNaissance;
            personneToUpdater.Profession = personne.Profession;
            personneToUpdater.Sexe = personne.Sexe;
        }

        this.modify();
    }

    public annuler(): void {
        if (this.salarieCharges[this.currentId] != undefined) {
            this.salarieCharges[this.currentId].isModified = false;
        }
        this.fetchData();
        this.isModified = false;
        this.$emit("isModified", false);
    }

    public modify(): void {
        this.isModified = false;
        this.isModified = true;
        this.$emit("isModified", true);
    }

    public refreshDeclaration(): void {
        this.fetchData();
    }
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/declarations/declarationsSalarie.ts